<template>
  <div class="init">
    <div class="page_main_content">
      <div class="flexContent">
        <!-- 轮播图 -->
        <div class="bannerContainer">
          <div class="school_banner"></div>
        </div>
        <p class="content_title">请输入缴费信息进行缴费</p>
        <!-- 校验表单 -->
        <div class="form_container">
          <van-cell-group>
            <van-field label="学校名称" :value="params.school_name" readonly />
            <van-field label="缴纳项目" :value="params.expense_name" readonly />
            <van-field label="缴纳金额" :value="params.expense" readonly />

            <div class="vanList-item" @click="openShow">
              <van-field label="缴纳年级" placeholder="请选择缴纳年级" :value="params.garde" required readonly />
              <van-icon name="arrow" />
            </div>

            <div class="vanList-item" @click="openShow2()">
              <van-field label="缴纳班级" placeholder="请选择缴纳班级" :value="params.className" required readonly />
              <van-icon name="arrow" />
            </div>
<!--            <van-field label="缴纳班级" placeholder="请输入缴纳班级(1班)" v-model="params.className" required />-->
            <van-field label="学生姓名" v-model="params.name" placeholder="学生姓名" required clearable/>
            <van-field placeholder="请输入手机号码" v-model="params.phone" type="number" maxlength="11" label="手机号" required clearable/>
            <van-field label="备注" v-model="params.masks" placeholder="请输入备注" clearable />
          </van-cell-group>

          <!-- 年级展示 -->
          <van-popup v-model="isShow2" position="bottom" :style="{ height: '260px' }">
            <p class="select-list-li boderBottomLine" v-for="(item,index) in gardeList" :key="index" @click="schoolType(item)">{{item}}</p>
          </van-popup>
          <!-- 班级展示 -->
          <van-popup v-model="isShow5" position="bottom" :style="{ height: '260px' }">
            <p class="select-list-li boderBottomLine" v-for="(item,index) in classList" :key="index" @click="schoolNum(item)">{{ item }}</p>
          </van-popup>


        </div>
        <p class="pay_input_tips">说明：此页面用于非学号缴费，若使用学号缴费，请返回<span class="back" @click="$router.push('/index')">上一页</span></p>
        <div class="go_pay_btn" @click="pay">缴纳</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiSchoolGetIssue, apiSetOreder, apiSchoolChooseClass } from "@/api/api";
import {Message} from "element-ui";

export default {
  name: "payInput",
  data() {
    return {
      isShow2: false,
      isShow5: false,
      schoolIssueList: [],
      schoolListType: {   // 筛选出来的学校数据
        type:'',
        num:[]
      },
      params:{
        school_name:'',
        expense_name:'',
        expense:'',
        garde:"",
        className:'',
        phone:'',
        name:'',
        masks:'',
        schoolId:'',
        expense_id:''
      },
      gardeList: [],
      gardeArr: [],
      classList: [],
    }
  },
  created() {
    apiSchoolGetIssue({
      issue_id: this.$route.query.issue_id
    }).then(res=>{


      // 总数据
      var schoolIssueList = res.data;
      if(schoolIssueList){
        this.dataLssueList = res.data.issue;
        this.dataSchoolList = res.data.school;
        this.dataSchoolDataList = res.data.school_data;

        apiSchoolChooseClass({
          school_id: schoolIssueList.school.id
        }).then( res=> {
          this.gardeList = Object.keys(res.data);
          this.gardeArr = res.data;
        })



        this.params.school_name = this.dataSchoolList.name;
        this.params.expense_name = this.dataLssueList.expense_name;
        this.params.expense = this.dataLssueList.expense;
        this.params.schoolId = this.dataSchoolList.id;
        this.params.expense_id = this.dataLssueList.expense_id;
      }
      // 根据学校类型 判断年级和班级
      let schooltype = this.dataSchoolList.type;
      if(schooltype == 'kindergarten'){
        this.schoolListType.type = this.dataSchoolDataList.kindergarten_grade;
        for(let i = 1 ; i <= this.dataSchoolDataList.kindergarten_class_num ; i++){
          this.schoolListType.num.push(i + '班')
        }
      }else{
        let a = schooltype.indexOf("_");
        let b = schooltype.substring(0, a);
        if (b =='primary') {    // 小学
          this.schoolListType.type = this.dataSchoolDataList.primary_grade;
          console.log(this.schoolListType)
          for (let i = 1; i <= this.dataSchoolDataList.primary_class_num; i++) {
            this.schoolListType.num.push(i + '班')
          }
        }else if (b == 'middle'){    // 初中
          this.schoolListType.type = this.dataSchoolDataList.middle_grade;
          for(let i = 1 ; i <= this.dataSchoolDataList.middle_class_num ; i++){
            this.schoolListType.num.push(i + '班')
          }
        }else if (b == 'senior'){    // 高中
          this.schoolListType.type = this.dataSchoolDataList.senior_high_grade;
          for(let i = 1 ; i <= this.dataSchoolDataList.senior_high_class_num ; i++){
            this.schoolListType.num.push(i + '班')
          }
        }
      }
    })


  },
  methods:{
    // 展开弹窗
    openShow(){
      this.isShow2 = true;
    },
    openShow2() {
      if(!this.params.garde) {
        Message.error('请选择缴纳年级')
        return;
      }
      this.isShow5 = true;
    },
    // 选择年级
    schoolType(val){
      this.params.garde = val;
      this.isShow2 = false;
      this.classList = this.gardeArr[val];
    },
    // 选择班级
    schoolNum(val){
      this.params.className = val;
      this.isShow5 = false;
    },
    // 缴纳
    pay(){
      var n = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if(!this.params.garde){
        Message.error('请输入年级')
        return;
      }
      if(!this.params.className){
        Message.error('请输入缴纳班级')
        return;
      }
      if(!this.params.name){
        Message.error('请输入学生姓名')
        return;
      }
      if(!this.params.phone){
        Message.error('请输入手机号码')
        return;
      }else if(this.params.phone && this.params.phone.length !== 11){
        Message.error('请输入11位手机号码')
        return
      }else if(this.params.phone && !n.test(this.params.phone)){
        Message.error('请输入正确的手机号码')
        return
      }
      apiSetOreder({
        school_name: this.params.school_name,
        school_id: this.params.schoolId,
        grades: this.params.garde,
        classes: this.params.className,
        name: this.params.name,
        phone: this.params.phone,
        expense_name: this.params.expense_name,
        price: this.params.expense,
        remark: this.params.masks,
        expense_id: this.params.expense_id,
        openid: '',
        returnurl: ''
      }).then(res=>{
        if(res.code == 1){
          this.$router.push('/payInfo?order_no='+res.data.order_data.order_no)
        }else{
          Message.error('请输入正确的信息')
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
/deep/ .van-popup{
  overflow-y: auto;
}
/deep/ .van-icon{
  position: absolute!important;
  right: 25px;
  font-weight: 600;
  color: #a3a3a7;
}
/deep/ .el-checkbox__inner{
  border-radius: 50%;
}
/deep/ .van-icon-success:before{
  color: white;
}
/deep/ .van-radio-group .van-icon{
  position: initial!important;
}
/deep/ .van-radio{
  height: 13.33333vw;
  line-height: 13.33333vw;
  font-size: 4.8vw;
  color: #333;
  text-align: center;
  border-bottom: 1px solid #dddddd;
  padding: 0 15px;
}
/deep/ .van-radio__label{
  display: flex;
  flex: 1;
  font-size: 15px;
}
/deep/ .van-radio__label .title{
  flex: 1;
  text-align: left;
}
.init {
  .bannerContainer {
    height: 42.66667vw;

    .school_banner {
      height: 100%;
      background: url(../../../static/images/scool/payInput/background.png) no-repeat;
      background-size: cover;
    }
  }

  .content_title {
    height: 10.66667vw;
    color: #999999;
    line-height: 10.66667vw;
    font-size: 3.2vw;
    padding-left: 4vw;
  }
  .pay_input_tips{
    text-align: center;
    font-size: 3.2vw;
    color: #999;
    line-height: 4.53333vw;
    margin: 4vw 0;

  }
  .go_pay_btn{
    margin: 6.66667vw 4vw;
    height: 11.73333vw;
    text-align: center;
    font-size: 4.8vw;
    line-height: 11.73333vw;
    border-radius: 1.06667vw;
    color: #fff;
    background: #3b74ff;
  }
  .vanList-item{
    display: flex;
    align-items: center;
    span{
      font-family: SimSun;
      font-size: 4vw;
      font-weight: 600;
      color: #ccc;
    }
  }
  .select-list-li{
    height: 13.33333vw;
    line-height: 13.33333vw;
    font-size: 4.8vw;
    color: #333;
    text-align: center;
    border-bottom: 1px solid #dddddd;
  }
  .am-modal-title{
    line-height: 13.06667vw;
    text-align: center;
    color: #333;
    font-size: 4.8vw;
    border-bottom: 1px solid #eeeeee;
  }
  .select-list-li2{
    padding: 0 16px;
    max-height:40vw;
    overflow-y: auto;
    line-height: 13.06667vw;
    color: #333;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    align-items: center;
    span{font-weight: 600}
    .title{
      flex: 1;
      margin-left: 10px;
    }
  }
  .sure_btn{
    margin: 9.33333vw 4vw 3.2vw;
    height: 11.73333vw;
    text-align: center;
    line-height: 11.73333vw;
    border-radius: 0.8vw;
    font-size: 4.8vw;
    background: #3b74ff;
    color: #FFFFFF;
  }
  .self_support_btn{
    margin: 0 4vw 4vw;
    height: 11.73333vw;
    text-align: center;
    line-height: 11.73333vw;
    border-radius: 0.8vw;
    font-size: 4.8vw;
    color: #333;
    border: 1px solid #e5e5e5;
  }
  .back{
    color: #3b74ff;
    text-decoration:underline;
  }
}
/deep/ .van-popup--bottom{
  max-height: 445px;
  min-height: 260px;
  height: auto!important;
}
/deep/ .van-radio-group{
  max-height: 220px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/index.vue